import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchProducts(category) {
  const params = category && category !== "All" ? { category } : {};
  const { data } = await api.get("/products", { params });
  return data;
}
export async function fetchProduct(slug) {
  const { data } = await api.get(`/products/${slug}`);
  return data;
}
export async function uploadArtwork(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}
export async function createOrder(payload) {
  const { data } = await api.post("/orders", payload);
  return data;
}
export async function fetchOrder(orderNumber) {
  const { data } = await api.get(`/orders/${orderNumber}`);
  return data;
}
export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}
export async function adminListProducts(pw) {
  const { data } = await api.get("/admin/products", { headers: { "x-admin-password": pw } });
  return data;
}
export async function adminCreateProduct(pw, payload) {
  const { data } = await api.post("/admin/products", payload, { headers: { "x-admin-password": pw } });
  return data;
}
export async function adminUpdateProduct(pw, id, payload) {
  const { data } = await api.patch(`/admin/products/${id}`, payload, { headers: { "x-admin-password": pw } });
  return data;
}
export async function adminDeleteProduct(pw, id) {
  const { data } = await api.delete(`/admin/products/${id}`, { headers: { "x-admin-password": pw } });
  return data;
}
export async function adminListOrders(pw) {
  const { data } = await api.get("/admin/orders", { headers: { "x-admin-password": pw } });
  return data;
}
